import { US_ID, CA_ID } from "./constants";
import {
  addressSchema,
  addressSchemaCA,
  billingAddressSchema,
  billingAddressSchemaCA,
} from "./validations";

export interface countryConfigModel {
  country: string;
  country_id: number;
  address2: boolean;
  stateLabel: string;
  zipLabel: string;
  addressSchema: typeof addressSchema;
  billingAddressSchema: typeof billingAddressSchema;
}

export const us = {
  address: {
    country: "US",
    country_id: US_ID,
    address2: true,
    stateLabel: "State",
    zipLabel: "Zip Code",
    addressSchema: addressSchema,
    billingAddressSchema: billingAddressSchema,
  },
  country: "U.S.",
  monthlySubCost: "39",
};

export const ca = {
  address: {
    country: "CA",
    country_id: CA_ID,
    address2: false,
    stateLabel: "Province",
    zipLabel: "Postal Code",
    addressSchema: addressSchemaCA,
    billingAddressSchema: billingAddressSchemaCA,
  },
  country: "Canada",
  monthlySubCost: "49",
};

export const countryConfig = () => {
  return process.env.NEXT_PUBLIC_COUNTRY_CODE === "CA" ? ca : us;
};
